// extracted by mini-css-extract-plugin
export default {"styledForm":"form-common_styledForm__TaPk+","checkboxContainer":"form-common_checkboxContainer__YgzMg"};